import { FormElement, RadioBox } from "@/components";
import { Box, Flex, Select } from "@chakra-ui/react";
import { PAID_MODE_GROUP } from "@shared/client";
import { useEffect } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { CustomInputTitle, CustomTitle } from "./payerInfo.style";
import { PayerInfoProps } from "./payerInfo.type";

export const PayerInfo = ({ control, account, use, onlyUseAccount }: PayerInfoProps) => {
    const { setValue } = useFormContext();
    const payMethod = useWatch({ control, name: "payMethod" });

    useEffect(() => {
        if (payMethod !== "account") setValue("bank", "");
    }, [payMethod]);

    const updatedPaymentModes =
        onlyUseAccount === "true"
            ? PAID_MODE_GROUP.filter((mode) => mode.name === "account")
            : use === "true"
              ? PAID_MODE_GROUP
              : PAID_MODE_GROUP.filter((mode) => mode.name !== "account");

    return (
        <Flex flex="1" flexDir="column" rowGap="24px" borderRadius="16px" boxSizing="border-box">
            <>
                <CustomTitle>예약정보입력</CustomTitle>
                <Flex flexDir="column">
                    <CustomInputTitle>예약자정보</CustomInputTitle>
                    <Box>
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="text"
                            placeholder="예약자 성함"
                            name="buyer"
                            id="buyer"
                            label="예약자명"
                            value=""
                            isRequired={true}
                        />
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="tel"
                            placeholder="ex)010-0000-0000"
                            name="phoneNumber"
                            id="phoneNumber"
                            label="연락처"
                            value=""
                            isRequired={true}
                        />
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="text"
                            placeholder="예약 시 요청사항"
                            name="memo"
                            id="memo"
                            label="예약시 요청사항"
                            value=""
                            isRequired={false}
                        />
                    </Box>
                </Flex>
                <Flex flexDir="column" gap="8px">
                    <CustomInputTitle>결제수단</CustomInputTitle>
                    <RadioBox control={control} name="payMethod" option={updatedPaymentModes} />
                </Flex>
                {use === "true" && payMethod === "account" && (
                    <Flex flexDir="column" gap="8px">
                        <CustomInputTitle>입금 계좌선택</CustomInputTitle>
                        <Controller
                            control={control}
                            name="bank"
                            defaultValue=""
                            render={({ field }) => (
                                <Select {...field} placeholder="입금계좌선택">
                                    {account.map((it: { [key: string]: any }, index: number) => (
                                        <option value={it.bank} key={index}>
                                            {it.bank}
                                        </option>
                                    ))}
                                </Select>
                            )}
                        />
                    </Flex>
                )}
            </>
        </Flex>
    );
};
